import { engineComponent, ArrayUtils } from "neo-common";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { PaylinesDefinitions } from "./PaylinesDefinitions";
import { Payline } from "./Payline";
import { Configuration } from "../Components/Configuration";
import { ComponentTypes } from "../Components/ComponentTypes";

/**
 * Paylines class is holder for all paylines.
 * Paylines define behaviour of paylines on screen.
 * @class Paylines
 * @extends ContainerElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class Paylines extends ContainerElement {
    paylineDefinition: string;

    private _paylineIDs: Array<number>;
    private _paylines: Array<Payline>;
    private _specialContainer: ContainerElement;

    constructor() {
        super();

        this._paylines = [];
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    createByNode(node: Element) {
        super.createByNode(node);

        /*
         * Name of config for paylines.
         * @property Configs
         * @type string
         * @default null
         */
        if (node.hasAttribute("Configs")) {
            var configs: Array<string> = node.getAttribute("Configs").split(";");
            for (var i: number = 0; i < configs.length; i++) {
                var config: Element = Configuration.Configurations[configs[i]];
                if (config != null) {
                    this.configurate(config);
                }
            }
        }

        if (this.childs != null) {
            for (var key in this.childs) {
                if (this.childs[key] instanceof Payline) {
                    this._paylines.push(this.childs[key]);
                }
            }

            this.children.sort((a: any, b: any) => {
                if (a.hasOwnProperty("zIndex") && b.hasOwnProperty("zIndex")) {
                    a.zIndex = a.zIndex || 0;
                    b.zIndex = b.zIndex || 0;

                    return a.zIndex - b.zIndex;
                }

                return 0;
            });
        }
    }

    setSpecialContainer(container: ContainerElement): void {
        this._specialContainer = container;
    }

    /**
     * Get attributes from configuration and set up supported properties.
     * @method configurate
     * @param node is Element from xml
     * @return void
     */
    configurate(node: Element): void {
        /*
         * PaylineIDs defines ids of payline used for game.
         * @property PaylineIDs
         * @type Array<number>
         * @default null
         */
        if (node.hasAttribute("PaylineIDs")) {
            this._paylineIDs = ArrayUtils.numberArray(node.getAttribute("PaylineIDs"));
        }

        /*
         * Initialize paylines definitions for game.
         * @property PaylineDefinition
         * @type String
         * @default null
         */
        if (node.hasAttribute("PaylineDefinition")) {
            this.paylineDefinition = node.getAttribute("PaylineDefinition");
            PaylinesDefinitions.initializePaylineDefinitions(node.getAttribute("PaylineDefinition"));
        }
    }

    showPaylinesLabel(): void {}

    /**
     * Set winning payline from response to case WIN.
     * @method goToWin
     * @param id number
     * @return void
     */
    goToWin(id: number): void {
        if (this._paylines[id - 1] != null) {
            this.addChild(this._paylines[id - 1]);
            this._paylines[id - 1].goToCase(Payline.CaseWin);
        } else {
            if (DEBUG) {
                this.log("ERROR no payline with id: " + (id - 1));
            }
        }
    }

    /**
     * Reset all paylines to case NORMAL.
     * @method reset
     * @return void
     */
    reset(): void {
        for (var i: number = 0; i < this._paylines.length; i++) {
            if (this._specialContainer != null) {
                this._specialContainer.addChild(this._paylines[i]);
            }
            this._paylines[i].goToCase(Payline.CaseNormal);
        }
    }

    getPaylines(): Array<Payline> {
        return this._paylines;
    }

    //******************************************************************************************************************
    //  NEW USAGE
    //******************************************************************************************************************

    public goToCase(caseType: string): void;
    public goToCase(caseType: string, id: number): void;

    public goToCase(caseType: string, id?: number): void {
        if (id) {
            if (this._paylines[id - 1] != null) {
                if (caseType === Payline.CaseWin) {
                    this.addChild(this._paylines[id - 1]);
                } else {
                    if (this._specialContainer != null) {
                        this._specialContainer.addChild(this._paylines[id - 1]);
                    }
                }

                this._paylines[id - 1].goToCase(caseType);
            } else {
                if (DEBUG) {
                    this.log("ERROR no payline with id: " + (id - 1));
                }
            }
        } else {
            for (let i = 0; i < this._paylines.length; i++) {
                if (caseType === Payline.CaseWin) {
                    this.addChild(this._paylines[i]);
                } else {
                    if (this._specialContainer != null) {
                        this._specialContainer.addChild(this._paylines[i]);
                    }
                }
                this._paylines[i].goToCase(caseType);
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Paylines.ts
 **/